var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgXuanze = function SvgXuanze(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "var(--primaryColor)",
    cx: 7,
    cy: 7,
    r: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.008 4.744a.658.658 0 0 0-.78.12L5.89 9.071a.027.027 0 0 1-.039 0L3.786 7.065a.658.658 0 0 0-.78-.12.576.576 0 0 0-.112.907l2.528 2.458c.25.238.642.238.892 0l4.799-4.674a.576.576 0 0 0-.105-.892Z",
    fill: "#FFF",
    fillRule: "nonzero"
  }))));
};

export default SvgXuanze;